<template>
  <v-container class="pa-0">
    <v-text-field
      type="text"
      label="Gatuadress*"
      outlined
      v-model="data.address"
      :rules="[formRules.required]"
      validate-on-blur
      required
      maxlength="40"
    ></v-text-field>
    <v-text-field
      type="text"
      label="Adressrad 2"
      outlined
      v-model="data.address2"
      maxlength="40"
    ></v-text-field>
    <v-text-field
      type="text"
      label="Postnummer*"
      outlined
      v-model="data.zip"
      :rules="[formRules.required]"
      validate-on-blur
      required
      maxlength="6"
    ></v-text-field>
    <v-text-field
      type="text"
      label="Postort*"
      outlined
      v-model="data.city"
      :rules="[formRules.required]"
      validate-on-blur
      required
      maxlength="40"
    ></v-text-field>
    <!--
    <v-text-field
      type="text"
      label="Bankkonto clearing nr"
      outlined
      v-model="data.bankClearingNumber"
      maxlength="10"
    ></v-text-field>
    <v-text-field
      type="text"
      label="Bankkontonummer"
      outlined
      v-model="data.bankAccountNumber"
      maxlength="20"
    ></v-text-field>
    -->
    <!--allowCompanyToView-->
    <template v-if="!data.freeDriverAccess">
      <!--only output if not freeDriverAccess (for company)-->
      <v-radio-group
        v-model="data.allowCompanyToView"
        label="Tillåt åkeriet se dina uppgifter när du matchar innan du signerar ett jobb*"
        :rules="[formRules.checked(data.allowCompanyToView)]"
        validate-on-blur
      >
        <v-radio
          v-for="yesNoOption in yesNoOptions"
          :key="yesNoOption.value"
          :label="yesNoOption.text"
          :value="yesNoOption.value"
        ></v-radio>
      </v-radio-group>
      <div class="text-caption">Om du tillåter detta underlättar du för åkeriet att ta kontakt med dig om de är intresserade av att ge ett jobb till dig</div>
    </template>
    <!--citizenship-->
    <v-radio-group
      v-model="data.citizenship"
      label="Medborgarskap*"
      :rules="[formRules.checked(data.citizenship)]"
      validate-on-blur
    >
      <v-radio
        v-for="citizenshipData in data.citizenshipData_ar"
        :key="citizenshipData.value"
        :label="citizenshipData.text"
        :value="citizenshipData.value"
      ></v-radio>
    </v-radio-group>
    <template v-if="citizenshipIsOutsideEu">
      <v-row>
        <v-col class="pt-0 pb-2">
          <div class="text-subtitle-1 text--secondary">Arbetstillstånd*</div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" class="py-0">
          <v-menu
            v-model="workingPermitFromMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="data.workingPermitFrom"
                readonly
                label="Fr o m*"
                outlined
                prepend-icon="mdi-calendar"
                v-bind="attrs"
                v-on="on"
                :rules="citizenshipIsOutsideEu ? [formRules.required, formRules.date]: []"
                :required="citizenshipIsOutsideEu"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="data.workingPermitFrom"
              @input="workingPermitFromMenu = false"
              dark
              first-day-of-week="1"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" class="py-0">
          <v-menu
            v-model="workingPermitUntilMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="data.workingPermitUntil"
                readonly
                label="T o m*"
                outlined
                prepend-icon="mdi-calendar"
                v-bind="attrs"
                v-on="on"
                :rules="citizenshipIsOutsideEu ? [formRules.required, formRules.date] : []"
                :required="citizenshipIsOutsideEu"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="data.workingPermitUntil"
              @input="workingPermitUntilMenu = false"
              dark
              first-day-of-week="1"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </template>
    <!--management-->
    <v-radio-group
      v-model="data.management"
      label="Regi*"
      :rules="[formRules.checked(data.management)]"
      validate-on-blur
    >
      <v-radio
        v-for="driverManagementData in data.driverManagementData_ar"
        :key="driverManagementData.value"
        :label="driverManagementData.text"
        :value="driverManagementData.value"
      ></v-radio>
    </v-radio-group>
    <v-text-field
      v-show="driverManagementIsCompany"
      type="text"
      label="Organisationsnummer*"
      outlined
      v-model="data.organizationNumber"
      :rules="driverManagementIsCompany ? [formRules.required,formRules.organizationNumber] : []"
      validate-on-blur
      :required="driverManagementIsCompany"
      maxlength="11"
    ></v-text-field>
  </v-container>
</template>

<script>
import { generalMixin } from '../mixins/general'

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  mixins: [generalMixin],
  data: () => ({
    workingPermitFromMenu: false,
    workingPermitUntilMenu: false
  }),
  computed: {
    driverManagementIsCompany() {
      return this.data.management && this.data.management === 'cmp'
    },
    citizenshipIsOutsideEu() {
      return this.data.citizenship && this.data.citizenship === 'ou'
    }
  },
  created() {
    console.log("DriverFormFields loaded")
  }
}
</script>

<style>

</style>